( function () {
	'use strict';

	function EvidenceCounter ( $q, dataservice, logger, $scope, _, $modal, TOOLTIP_MESSAGES, evidenceService ) {
		var self = this;

		$scope.$watch( 'model.masterEvidences', function ( val ) {
			if ( val ) {
				var newCounter      = _.filter( val, 'id',  $scope.counterEvidence.id )[ 0 ];

				self.counter        = parseInt( newCounter.description );

				$scope.counterTitle = newCounter.name;
			}
		}, true );

		function saveCount () {
			if ( self.counter ) {
				$scope.counterEvidence.name        = $scope.counterTitle;
				$scope.counterEvidence.description = self.counter.toString();
				return evidenceService.editDeleteEvidence( $scope.counterEvidence, 'edit', $scope.model );
			}

			self.counter = 0;

			$scope.counterEvidence.description = self.counter.toString();
			evidenceService.editDeleteEvidence( $scope.counterEvidence, 'edit', $scope.model );
		}

		self.incrementCounterHandler = function () {
			self.counter++;
			saveCount();
		};

		self.decrementCounterHandler = function () {
			if ( self.counter ) {
				self.counter--;
				saveCount();
			}
		};

		function deleteCounter () {
			var deleteEvidence = _.find( $scope.model.masterEvidences, { 'id' : self.prevUUID } );

			if ( deleteEvidence ) {
				evidenceService.editDeleteEvidence( deleteEvidence, 'delete', $scope.model );
			}

			return $scope.count.splice( $scope.index, 1 );
		}

		function deleteConfirmationModal () {
			var modalInstance = $modal.open( {
				'templateUrl'  : '/templates/components/delete-modal/delete-confirmation.html',
				'controller'   : 'DeleteConfirmationController',
				'controllerAs' : 'vm',
				'resolve'      : {
					'type' : function () {
						return 'Evidence';
					}
				}
			} );

			modalInstance.result.then( function () {
				deleteCounter();
			} );
		}

		self.checkEnterKey = function ( ev ) {
			if ( ev.keyCode === 13 ) {
				ev.preventDefault();
			}

			if ( $scope.counterTitle ) {
				$scope.counterEvidence.name = $scope.counterTitle;
				self.invalidTitle           = false;
				saveCount();
				return true;
			}

			self.invalidTitle = true;
		};

		self.deleteConfirmationModal = deleteConfirmationModal;
		self.deleteCounter           = deleteCounter;
		self.saveCount               = saveCount;

		function activate () {
			logger.info( 'Activated Templates-New View' );

			self.counter       = parseInt( $scope.counterEvidence.description );
			self.prevUUID      = $scope.counterEvidence.id;
			self.showOverlay   = false;
			self.confirmDelete = false;
			self.dataChanged   = false;
			self.tooltip       = TOOLTIP_MESSAGES;

			$scope.counterTitle = $scope.counterEvidence.name;
		}

		$scope.$on( 'check:running:timer:counter', function ( event, deleteEvidence ) {
			if ( self.prevUUID === deleteEvidence.id ) {
				$scope.count.splice( $scope.index, 1 );
			}
		} );

		activate();
	}

	angular.module( 'app.templates' ).controller( 'EvidenceCounter', EvidenceCounter );

	EvidenceCounter.$inject = [ '$q', 'coreservice', 'logger', '$scope', '_', '$modal', 'TOOLTIP_MESSAGES', 'evidenceService' ];
} )( );
